import React from "react";
import { Message, type SemanticCOLORS } from "semantic-ui-react";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const SaveByPayingPerYear = (props: Props) => {
  const colors = ["red", "green", "blue", "purple"] as SemanticCOLORS[];

  if (props.nextSubscriptionType.value !== "paid" || props.activeSubscription.billingCycle !== "monthly" || props.nextBillingCycle.value !== "monthly") {
    return <></>;
  }

  const randomColor = colors[Math.floor(Math.random() * colors.length)];

  return <div className="margin-top-large">
    <Message color={randomColor} style={{ textAlign: "center" }}>
      <div className="margin-bottom-small"><strong>{RESX.Subscription.SaveByPayingPerYear}</strong></div>
      <div>{RESX.Subscription.ContactUsToChangeBillingCycle}</div>
    </Message>
  </div>;
};

export default SaveByPayingPerYear;
